import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ContactsPlaceholderIcon = (props: IconProps) => (
  <Icon width="377px" height="374px" viewBox="0 0 377 374" {...props}>
    <ellipse
      opacity="0.38"
      cx="189.883"
      cy="187.556"
      rx="179.859"
      ry="179.765"
      fill="#F5F5F5"
    />
    <mask
      id="mask0_4503_74301"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="287"
      y="152"
      width="21"
      height="20"
    >
      <rect
        width="20.0463"
        height="18.9226"
        transform="matrix(-1 0 0 1 307.376 152.848)"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_4503_74301)">
      <path
        d="M257.26 205.164H303.329C294.493 205.164 287.329 198 287.329 189.164V168.848C287.329 160.012 294.493 152.848 303.329 152.848H257.26V205.164Z"
        fill="#FFF4E5"
      />
    </g>
    <path
      d="M287.33 152.848H28.0462C23.628 152.848 20.0462 156.43 20.0462 160.848V202.729C20.0462 207.147 23.628 210.729 28.0462 210.729H279.33C283.748 210.729 287.33 207.147 287.33 202.729V152.848Z"
      fill="#FFF4E5"
    />
    <line
      x1="2"
      y1="-2"
      x2="229.646"
      y2="-2"
      transform="matrix(-1 0 0 1 269.511 171.771)"
      stroke="#FFD599"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="2"
      y1="-2"
      x2="229.646"
      y2="-2"
      transform="matrix(-1 0 0 1 269.511 182.902)"
      stroke="#FFD599"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="2"
      y1="-2"
      x2="153.915"
      y2="-2"
      transform="matrix(-1 0 0 1 269.511 195.146)"
      stroke="#FFD599"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <ellipse
      cx="71.675"
      cy="209.606"
      rx="13.3642"
      ry="13.3571"
      fill="#FFD599"
    />
    <g clipPath="url(#clip0_4503_74301)">
      <path
        d="M64.5289 215.449H67.1275V207.658H64.5289V215.449ZM78.8212 208.307C78.8212 207.593 78.2365 207.009 77.5219 207.009H73.4226L74.0398 204.041L74.0593 203.833C74.0593 203.567 73.9488 203.32 73.7734 203.145L73.0848 202.463L68.8101 206.742C68.5697 206.976 68.4268 207.301 68.4268 207.658V214.151C68.4268 214.865 69.0115 215.449 69.7261 215.449H75.5729C76.1121 215.449 76.5734 215.125 76.7683 214.657L78.7302 210.08C78.7887 209.93 78.8212 209.775 78.8212 209.606V208.307Z"
        fill="white"
      />
    </g>
    <rect
      x="267.198"
      y="28.5776"
      width="56.7977"
      height="20.0357"
      rx="10.0179"
      fill="#E5F2FF"
    />
    <ellipse
      cx="278.335"
      cy="38.5951"
      rx="3.34105"
      ry="3.33929"
      fill="#99CAFF"
    />
    <ellipse
      cx="289.472"
      cy="38.5951"
      rx="3.34105"
      ry="3.33929"
      fill="#99CAFF"
    />
    <ellipse
      cx="300.609"
      cy="38.5951"
      rx="3.34105"
      ry="3.33929"
      fill="#99CAFF"
    />
    <ellipse
      cx="311.746"
      cy="38.5951"
      rx="3.34105"
      ry="3.33929"
      fill="#99CAFF"
    />
    <mask
      id="mask1_4503_74301"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="69"
      y="56"
      width="21"
      height="20"
    >
      <rect
        x="69.0481"
        y="56.6514"
        width="20.0462"
        height="18.9226"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask1_4503_74301)">
      <path
        d="M119.164 108.967H73.0945C81.931 108.967 89.0945 101.803 89.0945 92.9668V72.6514C89.0945 63.8149 81.931 56.6514 73.0945 56.6514H119.164V108.967Z"
        fill="#F2F8FF"
      />
    </g>
    <path
      d="M89.0944 56.6514H348.378C352.796 56.6514 356.378 60.2331 356.378 64.6514V106.532C356.378 110.951 352.796 114.532 348.378 114.532H97.0944C92.6761 114.532 89.0944 110.951 89.0944 106.532V56.6514Z"
      fill="#F2F8FF"
    />
    <line
      x1="108.913"
      y1="73.5742"
      x2="227.418"
      y2="73.5742"
      stroke="#CCE4FF"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="240.328"
      y1="73.5742"
      x2="335.445"
      y2="73.5742"
      stroke="#CCE4FF"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="108.913"
      y1="84.7051"
      x2="336.559"
      y2="84.7051"
      stroke="#CCE4FF"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="108.913"
      y1="96.9492"
      x2="165.052"
      y2="96.9492"
      stroke="#CCE4FF"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <mask
      id="mask2_4503_74301"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="63"
      width="72"
      height="72"
    >
      <ellipse
        cx="35.6378"
        cy="98.9486"
        rx="35.6378"
        ry="35.619"
        fill="#E5F2FF"
      />
    </mask>
    <g mask="url(#mask2_4503_74301)">
      <g clipPath="url(#clip1_4503_74301)">
        <rect
          width="104.877"
          height="221.856"
          transform="translate(-17.3099 57.2236)"
          fill="#E5F2FF"
        />
        <g clipPath="url(#clip2_4503_74301)">
          <path
            d="M23.3919 116.304C23.3919 116.304 12.1854 123.914 8.95459 156.658C6.68944 179.595 4.73425 187.657 4.73425 187.657L11.339 187.752C11.339 187.752 24.2503 155.625 25.4187 141.366C25.9671 134.635 23.3919 116.316 23.3919 116.316V116.304Z"
            fill="white"
          />
          <path
            d="M47.5098 116.007C47.5098 116.007 60.5165 121.064 63.3658 155.732C65.2495 178.693 67.1927 187.657 67.1927 187.657L60.588 187.752C60.588 187.752 47.6767 155.625 46.5083 141.366C45.9599 134.635 47.5217 116.007 47.5217 116.007H47.5098Z"
            fill="white"
          />
          <path
            d="M32.0353 113.561C27.815 113.822 23.1655 114.558 21.866 118.951C20.9957 124.935 23.8689 144.061 20.2327 163.627C15.1182 191.171 16.215 221.018 16.215 221.018L56.5466 221.315C56.5466 221.315 57.0593 191.183 52.9224 163.924C50.1208 145.474 52.4455 127.262 49.8346 118.939C48.4636 114.558 41.8708 114.131 39.6295 113.561C36.9233 112.433 35.6238 113.336 32.0353 113.561Z"
            fill="white"
          />
          <path
            d="M60.8146 87.7861C60.8146 101.724 49.465 113.027 35.4688 113.027C21.4725 113.027 10.1229 101.724 10.1229 87.7861C10.1229 73.8479 21.4725 62.5454 35.4688 62.5454C49.465 62.5454 60.8146 73.8479 60.8146 87.7861Z"
            fill="#323232"
          />
          <path
            d="M27.803 98.3405C27.803 98.3405 26.8492 93.0929 28.5421 89.8517C30.6642 85.7795 36.9947 83.5356 41.8708 87.869C45.2685 90.8846 43.4802 98.851 43.4802 98.851L32.8459 94.3514L27.803 98.3286V98.3405Z"
            fill="#323232"
          />
          <path
            d="M39.6295 113.561C39.6295 113.561 35.1707 115.912 32.0353 113.561L32.7029 105.417H38.9619L39.6295 113.561Z"
            fill="#29374F"
          />
          <path
            d="M29.1382 97.426C29.1382 97.426 28.2441 96.8442 27.5407 97.7703C26.8492 98.6963 27.3142 102.151 29.0428 102.151C30.7715 102.151 29.1263 97.426 29.1263 97.426H29.1382Z"
            fill="#29374F"
          />
          <path
            d="M42.5741 97.426C42.5741 97.426 43.4683 96.8442 44.1717 97.7703C44.8631 98.6963 44.4101 102.151 42.6695 102.151C40.9289 102.151 42.586 97.426 42.586 97.426H42.5741Z"
            fill="#29374F"
          />
          <path
            d="M42.8603 96.4645C42.8603 92.5822 39.7129 90.0415 35.8264 90.0415C31.9399 90.0415 28.7925 92.5822 28.7925 96.4645C28.7925 96.4645 28.4825 101.415 28.4825 101.665C28.4825 105.357 33.0248 110.035 35.8264 110.035C39.0691 110.035 43.1703 104.455 43.1703 101.665C43.1703 101.427 42.8603 96.4645 42.8603 96.4645Z"
            fill="#2F3D5B"
          />
          <path
            d="M28.9832 104.312C28.9832 104.312 29.0786 104.288 29.1263 104.265L28.9594 103.861C28.9594 103.861 28.8998 103.885 28.8759 103.885C28.101 104.098 27.2903 103.635 27.0757 102.852C26.8612 102.08 27.3261 101.273 28.1129 101.059L28.0057 100.644C26.9923 100.917 26.3843 101.961 26.6585 102.959C26.9327 103.968 27.9818 104.561 28.9952 104.3L28.9832 104.312Z"
            fill="white"
          />
          <path
            d="M42.5979 104.312C42.5979 104.312 42.4906 104.276 42.431 104.253C42.4787 104.264 42.6099 103.861 42.6099 103.861C42.6456 103.861 42.6814 103.885 42.7052 103.896C43.4802 104.11 44.2908 103.647 44.5054 102.864C44.72 102.092 44.2551 101.285 43.4682 101.071L43.5755 100.655C44.5889 100.928 45.185 101.973 44.9227 102.97C44.6485 103.98 43.5994 104.573 42.586 104.312H42.5979Z"
            fill="white"
          />
        </g>
      </g>
    </g>
    <rect
      x="84.8392"
      y="323.896"
      width="56.7977"
      height="20.0357"
      rx="10.0179"
      fill="#ECF9EF"
    />
    <ellipse
      cx="95.9761"
      cy="333.914"
      rx="3.34104"
      ry="3.33928"
      fill="#B3E5C0"
    />
    <ellipse
      cx="107.113"
      cy="333.914"
      rx="3.34104"
      ry="3.33928"
      fill="#B3E5C0"
    />
    <ellipse
      cx="118.25"
      cy="333.914"
      rx="3.34104"
      ry="3.33928"
      fill="#B3E5C0"
    />
    <ellipse
      cx="129.386"
      cy="333.914"
      rx="3.34105"
      ry="3.33928"
      fill="#B3E5C0"
    />
    <mask
      id="mask3_4503_74301"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="69"
      y="251"
      width="21"
      height="20"
    >
      <rect
        x="69.0481"
        y="251.192"
        width="20.0462"
        height="18.9226"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask3_4503_74301)">
      <path
        d="M119.164 303.508H73.0945C81.931 303.508 89.0945 296.344 89.0945 287.508V267.192C89.0945 258.356 81.931 251.192 73.0945 251.192H119.164V303.508Z"
        fill="#ECF9EF"
      />
    </g>
    <path
      d="M89.0944 251.192H348.378C352.796 251.192 356.378 254.774 356.378 259.192V301.073C356.378 305.492 352.796 309.073 348.378 309.073H97.0944C92.6761 309.073 89.0944 305.492 89.0944 301.073V251.192Z"
      fill="#ECF9EF"
    />
    <line
      x1="108.913"
      y1="268.115"
      x2="227.418"
      y2="268.115"
      stroke="#B3E5C0"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="240.328"
      y1="268.115"
      x2="335.445"
      y2="268.115"
      stroke="#B3E5C0"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="108.913"
      y1="279.246"
      x2="336.559"
      y2="279.246"
      stroke="#B3E5C0"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="108.913"
      y1="291.49"
      x2="165.052"
      y2="291.49"
      stroke="#B3E5C0"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <ellipse cx="316.5" cy="306.432" rx="13.3642" ry="13.3571" fill="#B3E5C0" />
    <g clipPath="url(#clip3_4503_74301)">
      <rect
        width="15.5915"
        height="15.5833"
        transform="translate(308.704 298.641)"
        fill="#B3E5C0"
      />
      <path
        d="M321.784 301.917L322.7 302.832L323.054 303.185L322.7 303.54L314.905 311.331L314.551 311.684L314.198 311.331L310.566 307.702L310.211 307.346L310.567 306.993L311.49 306.078L311.843 305.726L312.196 306.079L314.551 308.432L321.078 301.917L321.431 301.563L321.784 301.917Z"
        fill="white"
        stroke="white"
      />
    </g>
    <mask
      id="mask4_4503_74301"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="256"
      width="72"
      height="72"
    >
      <ellipse
        cx="35.796"
        cy="292.335"
        rx="35.6378"
        ry="35.619"
        fill="#FEEFEA"
      />
    </mask>
    <g mask="url(#mask4_4503_74301)">
      <g clipPath="url(#clip4_4503_74301)">
        <rect
          width="154.77"
          height="316.501"
          transform="translate(-41.5891 253.663)"
          fill="#B3E5C0"
        />
        <path
          d="M40.7698 255.26C47.8265 255.525 55.9189 262.928 55.1545 271.028C54.3901 279.127 51.8588 292.918 46.4916 293.194C44.1154 293.321 36.0838 290.155 36.0838 290.155L35.1311 299.813L20.0098 295.393L26.3353 283.011C26.3353 283.011 17.5172 254.387 40.7698 255.26Z"
          fill="#F7A283"
        />
        <path
          d="M44.2871 266.768C40.9138 271.536 40.4707 279.846 38.8478 272.072C38.0557 268.271 35.1367 268.359 32.9599 270.613C30.279 273.387 33.3421 277.315 32.6497 278.315C31.9573 279.31 27.2381 283.138 26.3408 283.011C25.4435 282.884 21.04 266.652 27.4486 258.519C34.4609 249.619 51.8367 254 53.2657 263.282C51.8145 262.834 47.6271 262.061 44.2926 266.774L44.2871 266.768Z"
          fill="white"
        />
        <path
          d="M26.507 293.089C19.5113 293.525 13.0528 300.801 8.54412 313.984C5.08226 337.752 -1.55896 421.129 -1.55896 421.129H61.8511C61.8511 421.129 53.2103 307.735 40.7034 298.1C35.7349 294.044 32.4503 292.724 26.5014 293.089H26.507Z"
          fill="#282644"
        />
        <path
          d="M26.4515 305.222C35.685 307.873 34.7267 325.205 16.3097 364.25L43.65 404.073L32.6551 413.847C32.6551 413.847 1.29352 386.106 -2.46189 369.929C-6.21731 353.752 9.41919 300.337 26.446 305.222H26.4515Z"
          fill="#282644"
        />
      </g>
    </g>
    <mask
      id="mask5_4503_74301"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="305"
      y="155"
      width="72"
      height="72"
    >
      <ellipse
        cx="340.786"
        cy="190.694"
        rx="35.6378"
        ry="35.619"
        fill="#FFFAE5"
      />
    </mask>
    <g mask="url(#mask5_4503_74301)">
      <g clipPath="url(#clip5_4503_74301)">
        <rect
          width="157.825"
          height="216.767"
          transform="translate(222.672 149.986)"
          fill="#FFFAE5"
        />
        <path
          d="M339.127 168.691C333.368 168.747 326.199 171.806 327.039 181.285C327.628 187.927 329.229 199.294 333.599 199.647C335.533 199.804 342.158 197.391 342.158 197.391L342.712 205.326L355.143 202.05L350.264 191.763C350.264 191.763 358.108 168.51 339.127 168.696V168.691Z"
          fill="#FFEACC"
        />
        <path
          d="M328.993 172.639L340.311 182.511C341.046 179.412 343.417 179.554 345.144 181.446C347.269 183.778 344.681 186.933 345.219 187.766C345.763 188.594 349.524 191.844 350.254 191.758C350.989 191.672 362.876 181.956 352.6 168.096C347.863 161.706 334.919 162.443 328.988 172.639H328.993Z"
          fill="#323232"
        />
        <path
          d="M334.642 158.294C334.772 162.852 337.693 165.613 341.831 165.497C345.964 165.381 347.767 162.347 347.641 157.789C347.51 153.231 345.234 149.87 341.096 149.986C336.958 150.102 334.511 153.731 334.642 158.289V158.294Z"
          fill="#323232"
        />
        <path
          d="M343.991 208.849C336.182 209.52 334.214 228.327 342.772 262.645L310.143 274.304L315.596 279.902C315.596 279.902 349.453 278.827 355.017 266.41C360.58 253.993 358.39 207.612 343.991 208.849Z"
          fill="white"
        />
        <path
          d="M339.213 201.177L378.891 191.43C378.891 191.43 386.951 216.627 366.979 217.803C347.012 218.984 339.218 201.177 339.218 201.177H339.213Z"
          fill="white"
        />
        <path
          d="M350.047 199.915C355.757 200.268 361.365 201.656 365.046 212.458C370.292 227.338 374.002 253.266 374.138 302.474L327.568 285.005C332.366 259.788 330.407 209.263 339.213 201.182C342.873 199.637 345.199 199.617 350.047 199.92V199.915Z"
          fill="white"
        />
        <path
          d="M352.746 210.651C344.912 210.671 342.969 230.129 351.528 264.446L324.668 273.486L324.351 281.709C324.351 281.709 358.209 281.577 363.772 269.161C369.335 256.744 361.819 210.636 352.746 210.656V210.651Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4503_74301">
        <rect
          width="15.5915"
          height="15.5833"
          fill="white"
          transform="translate(63.8793 201.814)"
        />
      </clipPath>
      <clipPath id="clip1_4503_74301">
        <rect
          width="104.877"
          height="221.856"
          fill="white"
          transform="translate(-17.3099 57.2236)"
        />
      </clipPath>
      <clipPath id="clip2_4503_74301">
        <rect
          width="62.4585"
          height="216.339"
          fill="white"
          transform="translate(4.73425 62.5454)"
        />
      </clipPath>
      <clipPath id="clip3_4503_74301">
        <rect
          width="15.5915"
          height="15.5833"
          fill="white"
          transform="translate(308.704 298.641)"
        />
      </clipPath>
      <clipPath id="clip4_4503_74301">
        <rect
          width="154.77"
          height="316.501"
          fill="white"
          transform="translate(-41.5891 253.663)"
        />
      </clipPath>
      <clipPath id="clip5_4503_74301">
        <rect
          width="157.825"
          height="216.767"
          fill="white"
          transform="translate(222.672 149.986)"
        />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(ContactsPlaceholderIcon);
